import { Component, Vue } from 'vue-property-decorator';
import { Getter } from 'vuex-class';
import BSSuggestionsListViewer from '../components/bookshop/suggestionsListViewer.vue';
import LSuggestionsListViewer from '../components/library/suggestionsListViewer.vue';
import { ViewerContext } from '../types/viewer_context';

@Component({ components: { BSSuggestionsListViewer, LSuggestionsListViewer } })
export default class SuggestionsList extends Vue {
  @Getter public viewerContext?: ViewerContext;
}
